//
// Button Select Controller
//
// Controls an input by pressing <button> or <a> elements
//
// See: /users/payment_schedules/form
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'option']
  static values = {
    default: Number,
  }
  static classes = ['active']

  connect() {
    this.currentValue = this.inputTarget.value || this.defaultValue
    this.render()
  }

  defaultValueChange() {
    this.render()
  }

  setOption(event) {
    event.preventDefault()
    this.currentValue = event.currentTarget.value

    this.render()
  }

  render() {
    this.optionTargets.forEach((option) => {
      if (option.value.toString() == this.currentValue.toString()) {
        option.classList.add(this.activeClass)
      } else {
        option.classList.remove(this.activeClass)
      }
    })

    this.inputTarget.value = this.currentValue
  }
}
